<template>
  <div class="responsible-stay-app mt-4">
    <ResponsibleStay :stationData="stationData" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ResponsibleStay from "@/vue/responsible-stay/components/ResponsibleStay.vue";
import useLocale from '@/vue/composables/useLocale';

// Reactive state
const locale = useLocale();
const stationId = window.lihe?.stationId;
const stationData = ref(null);

// Function to load station data
const loadStationData = async () => {
  try {
    const requestData = {
      locale: locale === 'fr_FR_CSE' ? 'fr_FR' : locale,
      stationId,
    };

    const res = await window.catalogService.getStationData(requestData);
    stationData.value = res;
  } catch (error) {
    console.error('Failed to fetch station data for ResponsibleStay:', error);
  }
};

// Fetch data when the component is mounted
onMounted(loadStationData);
</script>

<style scoped>
</style>
